<script>
import formInput from "@wielink-application/shared/js/mixins/formInput";

export default {
  mixins: [formInput],
  props: {
    'groupClasses': {
      type: String,
      required: false
    },
    'label': {
      type: String,
      required: false
    }
  }
}
</script>

<template>
  <textarea :name="name" @input="changeModelValue" :id="renderedId" :class="{'form-control': true, 'border-danger': hasError}" :value="modelValue"></textarea>
  <label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
</template>